import React from 'react';
import { Link } from 'react-router';
import './LegalPages.css';
import logo from '../assets/logo_prime.webp';
import backgroundImage from '../assets/image.png';
import Footer from './Footer';

const TermsAndConditions: React.FC = () => {
  return (
    <div className="legal-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="legal-container">
        <div className="legal-header">
          <Link to="/" className="logo-link">
            <img src={logo} alt="Prime Telehealth" className="legal-logo" />
          </Link>
          <h1>Terms and Conditions</h1>
        </div>

        <div className="legal-content">
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Prime Telehealth ("Service"), you accept and agree to be bound
              by the terms and provision of this agreement. If you do not agree to abide by the above, please
              do not use this service.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>
              Prime Telehealth is a digital platform that connects Australian patients with licensed healthcare
              professionals for virtual consultations, appointment scheduling, and healthcare management.
              Our Service includes:
            </p>
            <ul>
              <li>Virtual doctor consultations via video, audio, or chat</li>
              <li>Appointment scheduling and management</li>
              <li>Medical record storage and management</li>
              <li>Medicare claim processing and health fund integration</li>
              <li>Prescription management and delivery</li>
              <li>Health monitoring and tracking tools</li>
            </ul>
          </section>

          <section>
            <h2>3. User Accounts</h2>
            <h3>3.1 Account Creation</h3>
            <p>
              To use our Service, you must create an account by providing accurate and complete information.
              You are responsible for maintaining the confidentiality of your account credentials.
            </p>

            <h3>3.2 Account Responsibilities</h3>
            <p>You agree to:</p>
            <ul>
              <li>Provide accurate and up-to-date information</li>
              <li>Maintain the security of your password</li>
              <li>Notify us immediately of any unauthorized use</li>
              <li>Be responsible for all activities under your account</li>
            </ul>
          </section>

          <section>
            <h2>4. Medical Disclaimer</h2>
            <p>
              <strong>IMPORTANT:</strong> Our Service is not a substitute for emergency medical care.
              If you are experiencing a medical emergency, call 000 or go to the nearest emergency room immediately.
            </p>
            <p>
              The information provided through our Service is for informational purposes only and should not
              be considered as medical advice, diagnosis, or treatment. Always consult with qualified healthcare
              professionals for medical advice.
            </p>
          </section>

          <section>
            <h2>5. Healthcare Provider Qualifications</h2>
            <p>
              All healthcare providers on our platform are registered with the Australian Health Practitioner Regulation Agency (AHPRA)
              and licensed to practice in Australia. However, we do not guarantee the quality, accuracy, or completeness of medical advice provided.
              Users are responsible for verifying provider credentials and qualifications.
            </p>
          </section>

          <section>
            <h2>6. Payment Terms</h2>
            <h3>6.1 Fees and Billing</h3>
            <p>
              Consultation fees and other charges are clearly displayed before booking. Payment is required
              in advance for most services. We accept major credit cards, Medicare rebates, and health fund claims.
              All prices are displayed in Australian Dollars (AUD).
            </p>

            <h3>6.2 Refunds</h3>
            <p>
              Refunds are subject to our refund policy and may be provided in cases of technical issues,
              provider cancellations, or other qualifying circumstances as determined by us.
            </p>
          </section>

          <section>
            <h2>7. User Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the Service for any unlawful purpose</li>
              <li>Impersonate another person or entity</li>
              <li>Share false or misleading medical information</li>
              <li>Interfere with the proper functioning of the Service</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Use the Service to harass or abuse healthcare providers</li>
              <li>Violate any applicable laws or regulations</li>
            </ul>
          </section>

          <section>
            <h2>8. Intellectual Property</h2>
            <p>
              The Service and its original content, features, and functionality are owned by Prime Telehealth
              and are protected by Australian and international copyright, trademark, patent, trade secret, and other intellectual
              property laws.
            </p>
          </section>

          <section>
            <h2>9. Privacy and Data Protection</h2>
            <p>
              Your privacy is important to us. Please review our Privacy Policy, which also governs your use
              of the Service, to understand our practices regarding the collection and use of your information.
            </p>
          </section>

          <section>
            <h2>10. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by Australian law, Prime Telehealth shall not be liable for any
              indirect, incidental, special, consequential, or punitive damages, including without limitation,
              loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the Service.
            </p>
          </section>

          <section>
            <h2>11. Indemnification</h2>
            <p>
              You agree to defend, indemnify, and hold harmless Prime Telehealth and its officers,
              directors, employees, and agents from and against any claims, damages, obligations, losses,
              liabilities, costs, or debt, and expenses (including legal fees).
            </p>
          </section>

          <section>
            <h2>12. Termination</h2>
            <p>
              We may terminate or suspend your account and access to the Service immediately, without prior
              notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
            </p>
          </section>

          <section>
            <h2>13. Governing Law</h2>
            <p>
              These Terms shall be interpreted and governed by the laws of New South Wales, Australia,
              without regard to its conflict of law provisions.
            </p>
          </section>

          <section>
            <h2>14. Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time.
              If a revision is material, we will try to provide at least 30 days notice prior to any new
              terms taking effect.
            </p>
          </section>

          <section>
            <h2>15. Contact Information</h2>
            <p>
              If you have any questions about these Terms and Conditions, please contact us at:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> primetelehealthau@gmail.com</p>
              <p><strong>Phone:</strong> +61 469 755977</p>
              <p><strong>Address:</strong> 10 Trevithick Close, Stirling Western Australia 6021, Australia</p>
            </div>
          </section>
        </div>

        <div className="legal-footer">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
